import React from 'react'

function index() {
  return (
    <div>
      <h1>Hi I am product grid 2</h1>
    </div>
  )
}

export default index
